export default __webpack_public_path__ + "static/media/Amalganation.80839a0e.PNG";